import React from 'react';
import classNames from 'classnames';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import Label from './label';

export default class InputSlider extends React.Component {
  state = {};

  constructor(props) {
    super(props);
    this.state = {
      value: this.getInitialValue(props),
      realMin: this.getRealMinValue(props),
      numberInputValue: this.getInitialValue(props),
    };
    this.onSliderChange = this.onSliderChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({ value: this.getInitialValue(nextProps) });
    }
    if (nextProps.value !== this.props.value) {
      this.setState({ value: this.getInitialValue(nextProps) });
    }
    if (
      nextProps.min !== this.props.min ||
      nextProps.marks !== this.props.marks
    ) {
      this.setState({ realMin: this.getRealMinValue(nextProps) });
    }
  }

  getInitialValue(props) {
    const value = this.valueAdjusted(props.value || props.defaultValue, props);
    return Number(value);
  }

  getRealMinValue(props) {
    if (props.marks) {
      return +Object.keys(props.marks)[0];
    }
    return props.min;
  }

  value() {
    return this.state.value;
  }

  valueAdjusted(value, props = this.props) {
    const { min, max } = props;
    if (max !== undefined && value > max) {
      return max;
    } else if (min !== undefined && value < min) {
      return min;
    } else if (value === undefined) {
      return min;
    }
    return value;
  }

  onSliderChange(values) {
    clearTimeout(this.debounceTimeoutId);

    // We only care about the second value since we're using single handle mode
    const value = this.valueAdjusted(values[1]);

    this.setState({
      value,
      numberInputValue: value,
    });

    this.debounceTimeoutId = setTimeout(() => {
      const event = new Event('change', { bubbles: true });
      this.props.onChange(event, value);
    }, 300);
  }

  onInputChange(e) {
    const value = this.valueAdjusted(Number(e.target.value));
    const event = new Event('change', { bubbles: true });
    this.setState({ numberInputValue: value });
    this.props.onChange(event, value);
  }

  componentWillUnmount() {
    if (this.debounceTimeoutId) {
      clearTimeout(this.debounceTimeoutId);
    }
  }

  render() {
    const { id, label, help, max, step, disabled, className, small } =
      this.props;

    const { value, realMin } = this.state;

    const sliderValue = [realMin, value];
    return (
      <span
        className={classNames('form-slider', {
          'form-slider-small': small,
        })}
      >
        {label && <Label label={label} help={help} htmlFor={id} />}
        <span className="form-field-input">
          <RangeSlider
            id={id}
            min={realMin}
            max={max}
            step={step || 1}
            disabled={disabled}
            value={sliderValue}
            onInput={this.onSliderChange}
            className={`${disabled ? 'disabled' : ''} ${className || ''}`}
            thumbsDisabled={[true, false]}
            rangeSlideDisabled={true}
          />
          {this.props.numberInput && (
            <span className="form-slider-value">
              <input
                type="number"
                value={this.state.numberInputValue}
                min={realMin}
                max={max}
                onChange={this.onInputChange}
              />
              <span>{this.props.unit}</span>
            </span>
          )}
        </span>
      </span>
    );
  }
}
